<template>
  <div class="anniversary_page">
    <!-- 活动标题 -->
    <div v-wechat-title="'《使魔计划》周年庆典'"></div>
    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class='animated fadeIn' leave-active-class='animated fadeOut' name='fade'>
      <div @touchmove.prevent class='preloading preloading-smjh' v-show='preloadingShow'></div>
    </transition>
    <div class="content">

      <div class="swiper-container " ref="mySwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="first_page ">

              <div class="logo"></div>
              <div class="title"></div>
              <div class="btn_box">
                <div class="tap-btn " data-event="taptap"
                  @click="goHere('https://tap.cn/utZqQptX?channel=rep-rep_irbfyeyluhl')"> </div>
                <div class="wx-btn " data-event="wx" @click="goHere('wx')"> </div>
                <div class=" weibo-btn " data-event="weibo" @click="goHere('https://weibo.com/u/6573151992')"></div>
              </div>
              <div class=" download-btn download  android" @click="onDownloadApi"></div>
              <div class="arrow_down ani-01" @click="nextPage"></div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="second_page ">
              <div class="title"></div>
              <div class="btn_box">
                <div class=" prize_list-btn monitor-btn" data-event="prize_list"
                  @click=" openPopupNoAuth('prizeListShow')">
                </div>
                <div class=" price-btn monitor-btn" data-event="price" @click=" openPopup('myPrizeShow')"></div>
                <div class=" rule-btn monitor-btn" data-event="rule" @click="openPopupNoAuth('ruleShow')"></div>
              </div>
              <div class="function_btn_box">
                <div class="cut_btn" @click="lottery">
                  <div class="cut_text">剩余次数：{{ active_Info.times }}</div>
                </div>
                <div class="share_btn" @click="share"></div>
              </div>
              <div class="arrow_down ani-01" @click="nextPage"></div>
            </div>

          </div>
          <div class="swiper-slide">

            <div class="third_page ">
              <div class="title"></div>
              <!-- 设置左右切换按钮 -->
              <div class="swiper-button-next3 ani-btn"></div>
              <div class="swiper-button-prev3 ani-btn"></div>
              <div class="swiper-container1 swiper-class" ref="mySwiper1">
                <div class="swiper-wrapper">
                  <!-- 插入你的轮播内容 -->
                  <div class="swiper-slide" v-for="(item, index) in mdv" :key="index">

                    <img class="swiper-lazy" style="width: 100%;" :data-src="item.photo" alt="" />

                  </div>

                </div>

              </div>
              <div class="arrow_down ani-01" @click="nextPage"></div>
            </div>
            <div v-for="i in GifImages" style="display: none;">
              <img class="swiper-lazy" :data-src="i" />
            </div>
          </div>
          <div class="swiper-slide">
            <div class='content-page'>
              <div class="fourth_page ">
                <div class="title"></div>
                <div class="banner-box ani">
                  <img class="video-img" v-if="!isVideo"
                    src="https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/video.png"></img>

                  <div class="video-overlay">
                    <div class="play-button" v-if="!isVideo" @click="playVideo">
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="swiper-slide foot-page">
            <Footer :gameName="gameName" />
          </div>
        </div>
      </div>

    </div>





    <Header :config="headerConfig" :isShowInfo="true" :isOnline="1" />
    <!-- 登录弹窗 -->
    <Login v-if="isShowLogin" v-on:channelCallback="selectCallback" :gameName="gameName" :loginTypes="loginTypes"
      :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>
    <Os v-if="isShowOs" v-on:selectCallback="selectCallback" v-on:logoutCallback="osCancell" :gameName="gameName"></Os>

    <!-- 弹窗类 -->

    <!-- 视频详情 -->
    <div class="wx_wrap popup_wrap" v-show="isVideo">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">

        <video id="media-play" controls="controls" controlslist="nodownload" disablepictureinpicture="true"
          style="background-color: black;" ref="videoRef" v-show="isVideo" :src="videoSrc" autoplay
          @ended="isVideo = false"></video>



        <!-- 
        <video ref="videoRef" v-show="isVideo"
          src="https://download4.qcplay.com/qcgame-admin/FFpeBoVUvg1dqiywvkSFivXDxCRaecfklt7upP9j.mp4"
          @ended="isVideo = false" controls></video> -->
      </transition>
      <div v-show="isVideo" class="close-btn" @click="closeVideo">
        <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/login/close_icon.png" alt="关闭按钮" />
      </div>
      <div class="close-bg" v-if="isVideo" @click="closePopup('isVideo')"></div>
    </div>

    <!-- 微信下载 -->
    <div class="wx_download_wrap popup_wrap" v-show="wxLoadShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="wx_download_wrap_content" @click="closePopup('wxLoadShow')"></div>
      </transition>
      <div class="close-bg" v-if="wxLoadShow" @click="closePopup('wxLoadShow')"></div>
    </div>


    <!-- 抽中奖品 -->
    <div class="wx_wrap popup_wrap" v-show="getPriceShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <img class="price_img swiper-lazy" :src="priceShow" v-if="priceShow" />
      </transition>
      <div class="close-bg" v-if="getPriceShow" @click="closePopup('getPriceShow')"></div>
    </div>
    <!-- 微信详情 -->
    <div class="wx_wrap popup_wrap" v-show="wxShow">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="wxShow">
          <div class="detail">
            <img src="https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/wechat_pop.png" alt="详情">
          </div>
        </div>
      </transition>
      <div class="close-bg" v-if="wxShow" @click="closePopup('wxShow')"></div>
    </div>

    <!-- 我的奖品 -->
    <div class="my_price_wrap popup_wrap" v-show="myPrizeShow" @click="closePopup('myPrizeShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="my_price_pop " v-if="myPrizeShow">
          <div class="my_price_box_pop popup_box">
            <div class="popup_content">
              <div class="popup_list">
                <div class="popup_text" v-for="item in active_Info.reward_list" :key="item.id">
                  <div>{{ item.remark }}</div>
                  <div class="receive"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

    </div>


    <!-- 切蛋糕弹窗 -->
    <div class="cake_wrap popup_wrap" v-show="cakeShow">
      <div class="cake_ani">
      </div>
    </div>

    <!-- 奖品列表 -->
    <div class="price_wrap popup_wrap" v-show="prizeListShow" @click="closePopup('prizeListShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div class="detail_box" v-show="prizeListShow">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/price_list_text.png"
              alt="详情">
          </div>
        </div>
      </transition>
    </div>

    <!-- 分享相关DOM### -->
    <div :class="'help-share-wrap popup_wrap help-share-wrap-' + shareShow" ref="imageDom">
      <div class="help-share-box popup_wrap-box">
        <div class="bottom-img">
          <div class="link">
            <div class="link-text" id="link-text">{{ shareLink }}</div>
            <a class="link-btn" id="my-code" href="javascript:;" @click="onCopy('#my-code')"
              :data-clipboard-text='"《使魔计划》周年庆典现已开启！签到领取100抽，五星使魔以及橙色装备零元购，快来参与庆典吧！" + shareLink'></a>
          </div>
          <div class="qrcode-box">
            <div id="qrcode" class="qrcode"></div>
          </div>
        </div>
        <img :src="shareImg" alt="分享图片" />
        <div class="close-bg" v-show="shareShow" @click="closeShare()"></div>
      </div>
    </div>
    <!-- 规则列表 -->
    <div class="price_wrap popup_wrap" v-show="ruleShow" @click="closePopup('ruleShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }" v-show="ruleShow">
        <div class="detail_box" v-show="ruleShow">
          <div class="detail">
            <img class="swiper-lazy" src="https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/rule_text.png"
              alt="详情">
          </div>
        </div>
      </transition>
      <!-- <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
        :duration="{ enter: 1000 }">
        <div v-show="ruleShow" class="close-btn" @click="closePopup('ruleShow')">
          <img src="https://download4.qcplay.com/h5-images/login/close_icon.png" alt="关闭按钮" />
        </div>
      </transition> -->
    </div>

    <!-- 分享结果弹窗 -->
    <div class="assist_wrap popup_wrap" v-show="assistShow" @click="closePopup('assistShow')">
      <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active1"
        :duration="{ enter: 1000 }" v-show="assistShow">
        <div class="detail_box" v-show="assistShow">
          <div class="btn" @click="share"></div>
        </div>
      </transition>
    </div>


    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>




<script>

import Header from '@/components/Header/index';
import Footer from "@/components/Footer";
import { headerConfig } from "../headerConfig";

import MySwiper from '@/components/MySwiper';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Clipboard from 'clipboard';



// import { Toast, Indicator } from 'mint-ui';
import { Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onGetInitDataAPI, lottery, onDownloadApi } from '../api';
import { getRandomString, buriedLogger, wechatBrowser, getTimeStamp } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import Toast from '../components/toast/index.js';


export default {

  name: 'anniversary',
  components: {
    swiper,
    swiperSlide,
    MySwiper,
    Header,
    Footer,
    Login,
    Os
  },
  data() {
    return {
      mdv: [
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_2.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_3.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_1.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_4.png'
        },
        {
          photo: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/show_5.png'
        }
      ],
      videoSrc: '',
      headerConfig,
      noSwiperClass: '', // swiper-no-swiping
      gameName: "servitor",
      loginTypes: ["sms", "password", "channel"],
      downloadUrl: 'http://smjh.qingcigame.com/leading/',
      preloadingShow: true,
      titleShow: false,
      imagePath: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/party.png',
      imagePath1: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/gift.png',
      imagePath2: 'https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/carnival.png',
      swiperA: null,

      prizeListShow: false, // 奖品列表 弹窗
      myPrizeShow: false, // 奖品列表 弹窗
      ruleShow: false, // 奖品列表 弹窗
      cakeShow: false, //蛋糕列表 弹窗
      videoShow: false, //视频列表 弹窗
      GifImages: [],
      active_Info: {
        reward_list: [],
        times: 0
      }, // 活动信息
      user_info: {}, // 用户信息
      currentIndex: 1,
      gifInterval: null, // 定时器
      isUserInfo: false, // 是否获取用户信息
      shareLink: '',
      // 号码后4位id
      accountId: '',
      // 复制使用的文案
      clipInfo: '',
      shareShow: false,
      shareImg: null,
      getPriceShow: null,// 是否抽中奖
      priceShow: null,// 是否抽中奖
      isVideo: false, // 是否为视频
      wxShow: false,
      preventShow: false,
      paymentTipsShow: false,
      assistShow: false,

      isWechatBrowser: false, // 是否为微信浏览器
      wxLoadShow: false,
      swiper: null
    };
  },
  created() {
    var userAgent = navigator.userAgent.toLowerCase();
    var isPC = userAgent.indexOf('windows') > -1 || userAgent.indexOf('macintosh') > -1;

    if (isPC) {
      this.$router.push('pc');
      console.log('当前设备是 PC');
    } else {
      console.log('当前设备不是 PC');
    }


    this.getUserInfo()
    this.setInitActiveInfo();
    this.setInitUserInfo();


    this.isWechatBrowser = wechatBrowser();

    // 埋点
    const bl = buriedLogger('servitor', '使魔计划周年庆活动');
    this.logger = bl;

    const reload = () => {
      const { protocol, host } = window.location;
      const link = `${protocol}//${host}/servitor/anniversary/enter${getRandomString()}`;
      setTimeout(() => {
        window.location.href = `${link}?referer=game`;
      }, 200);
    };
  },
  mounted() {
    this.swiper = new Swiper('.swiper-container', {
      direction: 'vertical',
      resistanceRatio: 0,
      mousewheelControl: true,
      speed: 500,
      slidesPerView: 'auto',
      lazyLoading: true,
      lazyLoadingInPrevNext: true,
      preloadImages: false,
      observer: true,
      observeParents: true,

    });
    var swiper1 = new Swiper('.swiper-container1', {
      effect: 'coverflow',
      initialSlide: 2,
      slidesPerView: 3,
      centeredSlides: true,
      observer: true,
      observerParents: true,
      prevButton: '.swiper-button-prev3',
      nextButton: '.swiper-button-next3',
      speed: 500,
      coverflow: {
        rotate: 0,
        stretch: 10,
        depth: 12,
        modifier: 10,
        slideShadows: false
      },
    });

    function importAll(r) {
      const a = []
      for (var i = 3; i <= 92; i++) {
        a.push(`https://download4.qcplay.com/smjh/cake/${i}.png`)
      }
      return a
    }
    // this.GifImages = importAll().filter((v, i) => i < 50)
    this.initShareData()
    this.$set(this, 'GifImages', importAll())

  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"]),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.clearActiveInfo();
        }
      }
    },
    activeInfo: {
      handler(newValue, oldValue) {
        if (Object.keys(newValue).length > 0) {
          const { countdown_time = '', is_echarge } = newValue;
          this.showPayBtn = is_echarge === false;
          if (countdown_time) {
            const date = new Date(countdown_time);
            const curDate = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            const day = date.getDate();
            this.isExpired = curDate.getTime() > date.getTime();
            this.endDate = `${year}年${month}月${day > 9 ? day : ('0' + day)}日`
          } else {
            this.isExpired = true;
            this.endDate = '';
          }
        }
      }
    },
  },
  methods: {
    // 复制链接
    onCopy(my_id) {
      const clipboard = new Clipboard(my_id);
      console.log(clipboard, 'clipboard')
      clipboard.on('success', (e) => {
        console.log(clipboard, 'success')
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        console.log(clipboard, 'error')
        this.onToast('复制失败');
      });
      this.logger.sum('使魔计划周年庆H5，复制成功');
    },
    // 业务代码
    nextPage() {
      this.swiper.slideNext()
    },
    closeVideo() {
      this.isVideo = false
      this.videoSrc = ''
      this.$refs.videoRef.pause();
    },
    playVideo() {
      this.videoSrc = 'https://download4.qcplay.com/qcgame-admin/FFpeBoVUvg1dqiywvkSFivXDxCRaecfklt7upP9j.mp4'
      this.$refs.videoRef.play()
      this.isVideo = true
      this.logger.sum('使魔计划周年庆H5，播放视频');
    },
    onDownloadApi() {
      onDownloadApi().then(res => {
        const userAgent = navigator.userAgent;
        if (/iPhone|iPod/i.test(userAgent)) {
          this.logger.sum('使魔计划周年庆H5，ios下载');
          this.goHere(res.data["ios_down_url"]);
          if (this.isWechatBrowser) {
            // 微信浏览器
            this.wxLoadShow = true;
          }
        } else {
          this.logger.sum('使魔计划周年庆H5，安卓下载');
          const url = 'https://download4.qcplay.com/apk-v2/qc-kol-1143856.apk'
          console.log(url, 'android')
          this.goHere(url);
          if (this.isWechatBrowser) {
            // 微信浏览器
            this.wxLoadShow = true;
          }
        }
      })
    },
    goHere(link) {
      if (link === 'https://www.taptap.cn/app/7091') {
        this.logger.sum('使魔计划周年庆H5，taptap');
      }
      if (link === 'https://weibo.com/u/6573151992') {
        this.logger.sum('使魔计划周年庆H5，weibo');
      }

      if (link === 'wx') {
        this.logger.sum('使魔计划周年庆H5，微信');
        return this.wxShow = true
      }
      window.location.href = link
    },
    closeShare() {
      this.shareShow = false;
    },

    initShareData() {
      if (this.shareImg) return
      try {
        const { protocol, host } = window.location;
        this.shareLink = `${protocol}//${host}/servitor/anniversary/help${getRandomString()}?friend_id=` + this.user_info.user_id;
        this.$set(this, 'shareLink', this.shareLink)
        console.log('shareLink', this.shareLink);
        // this.shareLink = 'http://local.qingcigame.com:8081/servitor/anniversary/index'
        this.isSetShare(this.shareLink);
        this.qrcode(this.shareLink);
        this.$nextTick(() => {
          // this.generateShareImage();
        });
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log('err', err);
      }
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          console.log(canvas, 'canvas')
          this.preventShow = false;
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
          Indicator.close();
        })
        .catch((err) => {
          this.preventShow = false;
          Indicator.close();
          console.log('err: 图片生成失败', err.message);
        });

    },
    // 微信分享
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '《使魔计划》周年庆典',
        imgUrl:
          'https://download4.qcplay.com/qcgame-admin/H4U3DZVUyeRBrR99qRLyI0voEfzN9QAcHAY34FwA.png',
        desc: '《使魔计划》周年庆典现已开启！签到领取100抽，五星使魔以及橙色装备零元购，快来参与庆典吧！',
      })
    },
    qrcode(link) {
      generateQRCode(document.getElementById('qrcode'), {
        text: link,
        colorDark: '#b8957e',
        colorLight: '#f3eadb'
      });
    },
    monitoringEquipment() {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/sakura/lottery/pc${getTimeStamp()}`
    },
    share() {
      if (this.isUserInfo) {
        return this.onToast('很抱歉，请先登录')
      }
      this.logger.sum('使魔计划周年庆H5，分享弹窗');
      this.initShareData()
      this.shareShow = true
    },
    importAll(r) {
      return r.keys().map(r);
    },


    lottery() {
      if (this.isUserInfo) {
        console.log('请先登录')
        return this.onToast('很抱歉，请先登录');
      }
      const that = this
      lottery().then((response) => {
        if (response.code == 200) {
          console.log(response.data.prize_id, 'response.data.price_id')
          that.priceShow = `https://download4.qcplay.com/h5-images/active/servitor/anniversary/main/${response.data.prize_id}.png`
          this.cakeShowClose()
        } else {
          // this.onToast(response.message);
          this.assistShow = true
        }
        console.log(response)
      }).catch((e) => {
        console.log(e)

      })
    },
    // 获取用户信息
    async getUserInfo() {
      await onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
        this.preloadingShow = false;
        this.titleShow = true;
        if (response.code === 200) {
          this.active_Info = response.data.activity;
          console.log(this.active_Info)
          this.user_info = response.data.user_info;
          console.log(this.user_info)
          this.accountId = this.user_info.account.substr(-4);
          this.isUserInfo = false;
          // this.initShareData()

        } else {
          this.isUserInfo = true
          this.onToast(response.message);
          this.setInitUserInfo();
          this.setInitActiveInfo();
        }
      }).catch(() => {
        this.preloadingShow = false;
        this.titleShow = true;
      });
    },
    videoShowClose() {

    },
    cakeShowClose() {
      const that = this
      that.cakeShow = true;
      that.getUserInfo()
      this.logger.sum('使魔计划周年庆H5，参与抽奖');
      setTimeout(() => {
        that.closePopup('cakeShow')
        that.getPriceShow = true
      }, 6000)
    },

    // 清除data里面相关数据
    clearActiveInfo() {
      this.showPayBtn = true;
      this.endDate = '';
      this.isExpired = false;
    },
    // 选择角色后
    selectCallback() {
      this.shareImg = null
      this.getUserInfo();
    },
    osCancell() {
      this.active_Info = []
      this.user_info = []
      this.isUserInfo = true;
    },
    // TAG: 其他简易封装的方法
    openPopupNoAuth(name) {
      if (name == 'cakeShow') {
        this.logger.sum('使魔计划周年庆H5，奖品列表');
      }

      if (name == 'cakeShow') {
        this.logger.sum('使魔计划周年庆H5，规则列表');
      }
      this[name] = true;
    },
    // TAG: 其他简易封装的方法
    openPopup(name) {
      if (this.isUserInfo) {
        console.log('请先登录')
        return this.onToast('很抱歉，请先登录');
      }

      this.logger.sum('使魔计划周年庆H5，我的奖品');
      this[name] = true;
    },
    closePopup(name) {
      this[name] = false;
    },
    onToast(config) {
      const curConfig = {
        duration: 1300,
        className: "toasts",
        customStyle: { 'padding': '10px' }
      };
      if (!config) {
        console.error("缺少config参数");
        return false;
      }
      if (typeof config === "string") {
        curConfig.msg = config;
      }
      // Toast(curConfig);
      Toast.install(curConfig);
    },
    // TAG: 其他简易封装的方法
    tipsMessage(message, times) {
      this.tipsShow = true
      this.tips = message
      setTimeout(() => { this.tipsShow2 = true }, 100)
      setTimeout(() => { this.tipsShow2 = false }, times - 200)
      setTimeout(() => { this.tipsShow = false; this.tips = ''; }, times)
    },
    ...mapMutations([
      "changeLoginPopup",
      "changeOsPopup",
      "setInitActiveInfo",
      "setInitUserInfo",
      "setActiveInfo",
      "setLogger"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>
 


// WEBPACK FOOTER //
// src/pages/servitor/anniversary/index/index.vue